import { render } from "./PersonaCita.vue?vue&type=template&id=2d325c4c&scoped=true"
import script from "./PersonaCita.vue?vue&type=script&lang=js"
export * from "./PersonaCita.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=2d325c4c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d325c4c"]])

export default __exports__